import React from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";

export default function ThankYou() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const img = window.app?.img || "";

  if (!state?.name) {
    return <Navigate to="/" replace />;
  }

  const firstName = state.name.trim().split(/\s+/)[0] || "there";

  return (
    <div className="pc-root">

      {/* AMBER TOP ACCENT */}
      <div className="pc-ty-topbar" />

      {/* HEADER */}
      <header className="pc-header">
        <a href="/" className="pc-logo-link">
          <img
            src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`}
            alt="Orasi Logo"
            className="pc-logo-img"
          />
        </a>
      </header>

      {/* MAIN */}
      <main className="pc-ty-main">
        <div className="pc-ty-bg-left" />
        <div className="pc-ty-bg-right" />

        <div className="pc-ty-inner">

          <div className="pc-ty-check-wrap">
            <div className="pc-ty-check-ring" />
            <div className="pc-ty-icon">✓</div>
          </div>

          <h1 className="pc-ty-thankyou">Thank You</h1>

       

          <p className="pc-ty-greeting">
          
            <span className="pc-amber-text">{firstName}</span>
          </p>

          <p className="pc-ty-sub">
            We've received your registration for{" "}
            <strong>The Production Circle &amp; Formats</strong>.
          </p>

          <div className="pc-ty-contact">
            <p className="pc-ty-contact-label">For any queries or questions, contact us</p>
            <div className="pc-ty-contact-row">
              <span className="pc-ty-contact-item">
                <span className="pc-ty-contact-icon">✉</span>
                info@orasimedia.com
              </span>
              <span className="pc-ty-contact-sep" />
              <span className="pc-ty-contact-item">
                <span className="pc-ty-contact-icon">✆</span>
                +1 (201) 633 8748
              </span>
            </div>
          </div>

          <button className="pc-ty-btn-home" onClick={() => navigate("/")}>
            ← Back to Home
          </button>


        </div>
      </main>

      {/* FOOTER */}
      <footer className="pc-ty-footer">
        <span className="pc-footer-copy">© 2026 Orasi Media · The Production Circle &amp; Formats</span>
        <span className="pc-footer-copy">An invitation-only seminar · Mumbai</span>
      </footer>

    </div>
  );
}
